import {
    Goal,
    PackageTemplate,
    Partner,
} from '@raskrask-dk/bookingflow-state-machine'
import { GoalBF, ReviewBF } from '.'

type Education = string
export type Educations = Education[]
type GDPRLink = string | null
type Texts = Map<
    Goal['id'],
    {
        profileText: string
        tools: Competences
    }
>
export type Competence = {
    name: string
    text: string
    picture: string
}
export type Competences = Competence[]

export class PartnerBF extends Partner {
    education: string
    gdprLink: GDPRLink
    private _reviews: ReviewBF[]
    texts: Texts
    therapistPictureLink: string
    yotpoRating: number

    constructor(
        id: number,
        alias: string,
        education: string,
        gdprLink: GDPRLink,
        reviews: ReviewBF[],
        texts: Texts,
        therapistPictureLink: string,
        yotpoRating: number
    ) {
        super(id, alias)
        this.education = education
        this.gdprLink = gdprLink
        this._reviews = reviews
        this.texts = texts
        this.therapistPictureLink = therapistPictureLink
        this.yotpoRating = yotpoRating
    }

    public get numberOfReviews(): number {
        return this.reviews.length
    }

    public get rating(): number {
        return this.yotpoRating
    }

    public profileTextForGoal(goal: Goal): string {
        return this.texts.get(goal.id)?.profileText ?? ''
    }

    public competencesForGoal(goal: Goal): Competences {
        return this.texts.get(goal.id)?.tools ?? []
    }

    public get reviews(): ReviewBF[] {
        return this._reviews
    }

    public get t(): { unrated: string } {
        return {
            unrated: 'common:newatraskrask',
        }
    }

    public getPackageTemplates(goal: GoalBF): PackageTemplate[] {
        const allPackagesOnGoal = (goal as GoalBF).packages
        const packagesProvidedBySelectedPartner = allPackagesOnGoal.reduce(
            (packages, thisPackage) => {
                const thisPackageService = goal.services.find(
                    (service) => service.id === thisPackage.service.id
                )
                const doesPartnerDeliverThisPackage = thisPackageService
                    ?.getPartnersBy()
                    .find((thisPartner) => thisPartner === this)
                    ? true
                    : false
                if (doesPartnerDeliverThisPackage)
                    return [...packages, thisPackage]
                else return [...packages]
            },
            [] as PackageTemplate[]
        )
        return packagesProvidedBySelectedPartner as PackageTemplate[]
    }
}
